import React from 'react';
import {Badge} from '../Badge';
import {
  CompStatus,
  QuestionStatus,
} from '@chancer/common/lib/interfaces/firestore/FirestoreInterfaces';

interface IProps {
  status: CompStatus | QuestionStatus;
  published: boolean;
  template: boolean;
  size?: React.ComponentProps<typeof Badge>['size'];
}

export const StatusChip: React.FC<IProps> = (props) => {
  return (
    <Badge
      label={getLabel(props.status, props.published, props.template)}
      backgroundColor={getCompStatusColor(
        props.status,
        props.published,
        props.template,
      )}
      color="#fff"
      size={props.size}
    />
  );
};

export const getCompStatusColor = (
  status: CompStatus | QuestionStatus,
  published: boolean,
  template: boolean,
) => {
  switch (status) {
    case QuestionStatus.DRAFT:
    case CompStatus.DRAFT: {
      if (template) {
        return '#9e9e9e';
      } else if (published) {
        return '#ED9129';
      } else {
        return '#e61592';
      }
    }
    case QuestionStatus.OPEN:
    case QuestionStatus.OPEN_CHANGEABLE:
    case CompStatus.OPEN: {
      return '#63b700';
    }
    case QuestionStatus.INPLAY:
    case CompStatus.INPLAY: {
      return '#ffc800';
    }
    default: {
      return '#00a8e0';
    }
  }
};

const getLabel = (
  status: CompStatus | QuestionStatus,
  published: boolean,
  template: boolean,
) => {
  switch (status) {
    case QuestionStatus.DRAFT:
    case CompStatus.DRAFT: {
      if (template) {
        return 'TEMPLATE';
      } else if (published) {
        return 'UPCOMING';
      } else {
        return status;
      }
    }
    default: {
      return status;
    }
  }
};
